// extracted by mini-css-extract-plugin
module.exports = {"item":"Faq_item__tpBJo","active":"Faq_active__ZmyBt","label":"Faq_label__eNJoG","text":"Faq_text__0TKRn"};